import { useFormContext } from "react-hook-form"
import { OkAppsMeetingRecord } from "../dtos/OkAppsMeetingRecord"
import { useSelections } from "../hooks"
import { Insurer, Selection, SelectionType } from "BrokerTsLib/src/enums"
import { insurerOfferContext } from './hoc/WithOffer'
import { useContext } from "react"
import { FormLabel } from '../components/FormLabel'
import { InputGroup } from '../components/InputGroup'
import { FormControl, Select } from "@chakra-ui/react"

export const PreviousContractNumberForm = () => {
    const { register, formState: { errors }, getValues, watch } = useFormContext<OkAppsMeetingRecord>()

    const pcn = getValues('previousContractNumber')
    const overpaymentTypeId = watch('contractReplacementOverpaymentTypeId')
    const { offer } = useContext(insurerOfferContext)
    const { data: dataZv } = useSelections(SelectionType.ZpusobVraceniPreplatkuNahrazovaneSmlouvy)

    const showZpusobVraceniPreplatku = offer?.insurerId == Insurer.CPP

    if (!pcn) {
        return (<></>)
    }

    return (
        <>
            <FormControl>
                <FormLabel>Číslo stávající smlouvy</FormLabel>
                <InputGroup
                    {...register('previousContractNumber')}
                    isDisabled
                />
            </FormControl>

            {showZpusobVraceniPreplatku &&
                <>
                    <FormControl isInvalid={!!errors.contractReplacementOverpaymentTypeId?.message} isRequired>
                        <FormLabel>Způsob vrácení přeplatku z nahrazované smlouvy</FormLabel>

                        {dataZv &&
                            <Select {...register('contractReplacementOverpaymentTypeId')}>
                                <option value='' >Vyberte</option>
                                {dataZv?.data.map((item) => (
                                    <option value={item.id.toString()} key={item.id}>
                                        {item.description}
                                    </option>
                                ))}
                            </Select>
                        }
                    </FormControl>


                    {overpaymentTypeId && overpaymentTypeId == Selection.OverpaymentTypeBankTransfer &&
                        <FormControl isInvalid={!!errors.contractReplacementOverpaymentAccount?.message} isRequired>
                            <FormLabel>Číslo účtu</FormLabel>
                            <InputGroup
                                {...register('contractReplacementOverpaymentAccount')}
                                errors={errors.contractReplacementOverpaymentAccount}
                            />
                        </FormControl>
                    }
                </>
            }
        </>
    )
}